import Chart from "react-apexcharts";
import { colors } from "../../../global";

const TicketStatusDistribution = ({ data }) => {
  // Transform API result:
  // Extract labels (stage) and values (ticket_count)
  const categories = data.map((item) => item.stage);
  const series = [
    {
      name: "Ticket Count",
      data: data.map((item) => item.ticket_count),
    },
  ];

  return (
    <>
      <h2 className="text-lg font-semibold mb-4">Ticket Status Distribution</h2>

      <Chart
        key={JSON.stringify(series)}
        options={{
          chart: { type: "bar", toolbar: { show: false }, offsetY: 10 },
          xaxis: {
            categories,
            labels: {
              rotate: -45,
              style: { fontSize: "12px" },
              formatter: (val) => val.split("(")[0].trim(),
            },
          },
          colors: [colors.primary],
          plotOptions: {
            bar: {
              horizontal: false,
              borderRadius: 6,
              columnWidth: "50%",
            },
          },
          tooltip: {
            y: {
              formatter: (val) => `${val} ${val > 1 ? "Tickets" : "Ticket"}`,
            },
          },
        }}
        series={series}
        type="bar"
        height={250}
      />
    </>
  );
};

export default TicketStatusDistribution;
